import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Link } from 'react-router-dom';
import format from 'date-fns/format';

import { Button, Popconfirm, RecordSelect, DatePicker } from '@smartplatform/ui';
import store from '../../store';

import './style.scss';

@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;
	@observable statuses = [];
	@observable dueDate = null;
	@observable factDate = null;
	@observable place = '';
	@observable dueDateError = '';
	@observable factDateError = '';
	@observable placeError = '';

	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Appointment.findById(this.id, { include: ['deputy', 'status'] } );
				this.statuses = await store.model.AppointmentStatus.find({ order: 'id asc' });
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Appointment();
		}
		this.prepareDates();
	};
	
	prepareDates = () => {
		if (!this.record) return;
		if (this.record.statusId === 1) {
			const date = new Date(this.record.date);
			date.setHours(12);
			this.dueDate = date;
		}
		if (this.record.statusId === 2) {
			const date = new Date(this.record.dueDate);
			date.setHours(12);
			this.factDate = date;
		}
	};
	
	fio = record => <>
		{record.lastName} {record.firstName || ''} {record.middleName || ''}
	</>;
	
	delete = async () => {
		console.log('delete', this.record);
		await this.record.delete();
		this.props.history.push('/admin/appointments');
	};
	
	reset = async () => {
		this.record.dueDate = null;
		this.record.place = '';
		this.record.acceptDate = null;
		this.record.endDate = null;
		this.record.status = this.statuses[0];
		this.prepareDates();
		await this.record.save();
	};
	
	@action accept = async () => {
		this.dueDateError = '';
		this.placeError = '';
		if (!this.dueDate) {
			this.dueDateError = 'Введите дату приема';
			return;
		}
		if (this.place.trim().length === 0) {
			this.placeError = 'Введите место приема';
			return;
		}
		this.record.dueDate = this.dueDate;
		this.record.place = this.place;
		this.record.status = this.statuses[1];
		this.record.acceptDate = new Date();
		await this.record.save();
		this.prepareDates();
	};
	
	@action done = async () => {
		this.factDateError = '';
		if (!this.factDate) {
			this.factDateError = 'Введите фактическую дату приема';
			return;
		}
		this.record.status = this.statuses[2];
		this.record.endDate = new Date();
		this.record.factDate = this.factDate;
		await this.record.save();
	};
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		return <>
			<p>Запись на личный прием <strong>№ {this.record.id}</strong></p>
			<div>
				Депутат: <Link to={`/admin/deputies/${this.record.deputyId}`}><strong>{this.fio(this.record.deputy)}</strong></Link>
			</div>
			<div>
				Дата приема: <strong>{this.record.date ? format(new Date(this.record.date), 'dd.MM.yyyy') : '-'}</strong>
			</div>
			<div><br /></div>
			<div>
				Тема вопроса: <strong>{this.record.subject || '-'}</strong>
			</div>
			<div>
				Отправитель: <strong>{this.fio(this.record)}</strong>
			</div>
			<div>
				Контактный телефон: <strong>{this.record.phone || '-'}</strong>
			</div>
			<div>
				Адрес места жительства: <strong>{this.record.address || '-'}</strong>
			</div>
			<div>
				E-mail: {this.record.email && <a href={`mailto:${this.record.email}`}><strong>{this.record.email}</strong></a>}
			</div>
			<div>
				Сфера деятельности / место работы: <strong>{this.record.job || '-'}</strong>
			</div>
			<div>
				Социальная группа: <strong>{this.record.socialGroup || '-'}</strong>
			</div>
			<div>
				Категория: <strong>{this.record.category || '-'}</strong>
			</div>
			<div><br /></div>

{/*
			<div>
				<RecordSelect
					className="status-select"
					model={store.model.AppointmentStatus}
					property="name"
					value={this.record.status}
					onChange={this.onStatusChange}
					isRequired={true}
					noSearch={true}
					filter={{ order: 'id asc' }}
				/>
			</div>
			<div><br /></div>
*/}

			<div>
				Статус: <strong>{this.record.status ? this.record.status.name : '-'}</strong>
			</div>
			<div>
				Дата подтверждения заявки: <strong>{this.record.acceptDate ? format(new Date(this.record.acceptDate), 'dd.MM.yyyy HH:mm') : '-'}</strong>
			</div>
			<div>
				Назначенная дата приема: <strong>{this.record.dueDate ? format(new Date(this.record.dueDate), 'dd.MM.yyyy HH:mm') : '-'}</strong>
			</div>
			<div>
				Назначенная место приема: <strong>{this.record.place || '-'}</strong>
			</div>
			<div>
				Дата подтверждения приема: <strong>{this.record.endDate ? format(new Date(this.record.endDate), 'dd.MM.yyyy HH:mm') : '-'}</strong>
			</div>
			<div>
				Фактическая дата приема: <strong>{this.record.factDate ? format(new Date(this.record.factDate), 'dd.MM.yyyy HH:mm') : '-'}</strong>
			</div>
			<div><br /></div>
			
			<div className="appointment-edit">
				{this.record.statusId === 1 && <>
					<div className="row">
						<div className="col-lg-3 col-md-3 col-sm-3 form-field">
							<label>Дата приема</label>
							<DatePicker
								value={this.dueDate}
								onChange={date => this.dueDate = date}
								showTimeSelect={true}
							/>
							<div className="edit-error">{this.dueDateError}</div>
						</div>
						<div className="col-lg-3 col-md-3 col-sm-3 form-field">
							<label>Место приема (кабинет)</label>
							<input type="text" value={this.place || ''} onChange={e => this.place = e.target.value} />
							<div className="edit-error">{this.placeError}</div>
						</div>
					</div>
					<div>
						<Button className="btn-primary" onClick={this.accept}>Подтвердить заявку</Button>
					</div>
				</>}
				{this.record.statusId === 2 && <>
					<div className="row">
						<div className="col-lg-3 col-md-3 col-sm-3 form-field">
							<label>Фактическая дата приема</label>
							<DatePicker
								value={this.factDate}
								onChange={date => this.factDate = date}
								showTimeSelect={true}
							/>
							<div className="edit-error">{this.factDateError}</div>
						</div>
					</div>
					<div>
						<Button className="btn-primary" onClick={this.done}>Приём состоялся</Button>
					</div>
				</>}
			</div>
			
			<div><br /></div>
			
			<div><br />
				<Popconfirm content="Сбросить статус?" onConfirm={this.reset}>
					<a href="#" onClick={e => e.preventDefault()}>Сбросить статус</a>
				</Popconfirm>
				&nbsp;|&nbsp;
				<Popconfirm content="Удалить?" onConfirm={this.delete}>
					<a href="#" onClick={e => e.preventDefault()}>Удалить</a>
				</Popconfirm>
			</div>
		</>;
	}
	
}
